var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _path8, _path9, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-164.3 343.9 135.3 110.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n   @keyframes appear-1 {\r\n      0% { opacity: 0; }\r\n      5% { opacity: 1; }\r\n   }\r\n   @keyframes appear-2 {\r\n      0%, 5% { opacity: 0; }\r\n      10% { opacity: 1; }\r\n   }\r\n   @keyframes appear-3 {\r\n      0%, 10% { opacity: 0; }\r\n      15% { opacity: 1; }\r\n   }\r\n   @keyframes appear-4 {\r\n      0%, 15% { opacity: 0; }\r\n      20% { opacity: 1; }\r\n   }\r\n   @keyframes appear-5 {\r\n      0%, 20% { opacity: 0; }\r\n      25% { opacity: 1; }\r\n   }\r\n   @keyframes appear-6 {\r\n      0%, 25% { opacity: 0; }\r\n      30% { opacity: 1; }\r\n   }\r\n   @keyframes appear-7 {\r\n      0%, 30% { opacity: 0; }\r\n      80% { opacity: 1; }\r\n   }\r\n\r\n   #logo-1 {\r\n      animation: 5s infinite appear-1;\r\n   }\r\n\r\n   #logo-2 {\r\n      animation: 5s infinite appear-2;\r\n   }\r\n\r\n   #logo-3 {\r\n      animation: 5s infinite appear-3;\r\n   }\r\n\r\n   #logo-4 {\r\n      animation: 5s infinite appear-4;\r\n   }\r\n\r\n   #logo-5 {\r\n      animation: 5s infinite appear-5;\r\n   }\r\n\r\n   #logo-6 {\r\n      animation: 5s infinite appear-6;\r\n   }\r\n\r\n   #logo-7 {\r\n      animation: 5s infinite appear-7;\r\n   }\r\n   ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo-1",
    fill: "#EC1C24",
    d: "M-161.6,376.5c0,1.5,1.2,2.6,2.7,2.6c1.5,0,2.6-1.2,2.6-2.7c0-1.4-1.2-2.6-2.6-2.6C-160.4,373.8-161.6,375-161.6,376.5C-161.6,376.5-161.6,376.5-161.6,376.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "logo-2",
    fill: "#EC1C24",
    d: "M-148.6,363.7c0,2.3,1.8,4.1,4.1,4.1c2.3,0,4.1-1.8,4.1-4.1s-1.8-4.1-4.1-4.1l0,0C-146.8,359.6-148.6,361.4-148.6,363.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "logo-3",
    fill: "#EC1C24",
    d: "M-129.7,354.9c0,3.6,2.9,6.6,6.5,6.6c3.6,0,6.6-2.9,6.6-6.5c0-3.6-2.9-6.6-6.5-6.6c0,0,0,0,0,0C-126.7,348.3-129.7,351.3-129.7,354.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "logo-4",
    fill: "#EC1C24",
    d: "M-104.2,352.1c0,4.6,3.7,8.3,8.3,8.3c4.6,0,8.3-3.7,8.3-8.3c0-4.6-3.7-8.3-8.3-8.3C-100.4,343.9-104.2,347.6-104.2,352.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "logo-5",
    fill: "#EC1C24",
    d: "M-76.3,360.1c0,5.3,4.3,9.5,9.5,9.5s9.5-4.3,9.5-9.5s-4.3-9.5-9.5-9.5S-76.3,354.8-76.3,360.1L-76.3,360.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "logo-6",
    fill: "#EC1C24",
    d: "M-58.8,383.2c0,5.7,4.6,10.3,10.3,10.3s10.3-4.6,10.3-10.3S-42.8,373-48.5,373l0,0C-54.2,373-58.8,377.5-58.8,383.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M-117.7,390.9L-117.7,390.9c-1.2-4.2-4.8-7.2-9.1-7.6l0,0h-20.7v34.8h9.6v-12.7l10.8-0.1l0,0c0.3,0,7.2-0.7,9.3-7.5v-0.1c0.3-1.2,0.5-2.4,0.5-3.6C-117.2,393-117.4,391.9-117.7,390.9z M-137.9,389.3l8,0c1.4,0.4,2.5,1.5,2.8,3c0.1,0.6,0.2,1.2,0.2,1.8c0,0.7,0,1.4-0.3,2.1c-0.5,1.3-1.5,2.3-2.7,2.7h-8L-137.9,389.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -164.3,
    y: 383.2,
    fill: "#FFFFFF",
    width: 9.8,
    height: 34.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC1C24",
    d: "M-75,389.7V383h-24.8v34.9h9.7l-1-1l0,0l1,1c0,0,0-12.4,0-13.6H-76v-6.5h-14.2v-8.1H-75z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#EC1C24",
    d: "M-32,393.8c2.1-3.6,2.8-8.3,2.9-10.2l0.1-0.7h-7.2v0.6c-0.1,1.4-0.7,6.2-3.1,8.6c-2.9,2.9-5.9,3.9-9.2,4.9c-3.4-1-6.4-2-9.3-4.9c-2.4-2.4-3-7.1-3.1-8.6l-0.1-0.6h-7.1l0.1,0.7c0.2,1.9,0.8,6.6,2.9,10.2c2.7,4.5,8.1,7.5,8.1,7.5c-3.6,1.1-6.6,3.5-8.4,6.7c-1.7,2.9-2.3,7.4-2.4,9.3v0.7h11.4v-0.6c0-2.2,0.4-4.3,1-6.4c1.4-4.9,6.7-5.8,7-5.8s5.5,0.9,7,5.8c0.6,2.1,1,4.2,1,6.4v0.6h11.4l-0.1-0.7c-0.1-1.8-0.7-6.4-2.4-9.3c-1.8-3.2-4.9-5.6-8.4-6.7C-40,401.3-34.6,398.3-32,393.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-7"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -96.22 432.08)",
    fill: "#FFFFFF",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "18.1807px"
  }, "years"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -67.36 440.51)",
    fill: "#FFFFFF",
    fontFamily: "'Arial'",
    fontSize: "7px"
  }, "EST. 1995"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -137.89 441.8)",
    fill: "#FFFFFF",
    fontFamily: "'Arial-BoldMT'",
    fontSize: "34px"
  }, "25"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9b64647f23e9569034079f810265e9a0.svg";
export { ForwardRef as ReactComponent };